import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import {
  fetchData,
  fetchSubscriptionList,
  updateSubscription,
} from "src/services/dashboard.service";

export const doFetchData = createAsyncThunk(
  "dashboard/detchData",
  async (_) => {
    try {
      const response: any = await fetchData();
      return response.data;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch data";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);

export const doFetchSubscriptionList = createAsyncThunk(
  "dashboard/fetchSubscriptionList",
  async (_) => {
    try {
      const response: any = await fetchSubscriptionList();
      return response.data;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch subscription list";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);

export const doUpdateSubscription = createAsyncThunk(
  "dashboard/updateSubscription",
  async (data: any) => {
    try {
      const response: any = await updateSubscription(data);
      return response.data;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to update subscription";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);
